export default __webpack_public_path__ + "static/media/avataaars(4).c58bc733.png";